/**
 * @ngdoc directive
 * @name select-account
 *
 * @description
 * A list of radio buttons used to select an account
 */

module.directive('selectAccount', function() {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        scope: {
            onAccountChange: '&',
            accounts: '='
        },
        controller: ['$scope', 'moment', function ($scope, moment) {
            $scope.showInfo = true;

            $scope.onChange = function(account) {
                $scope.showInfo = false;
                $scope.onAccountChange({ account: account });
            }

            $scope.formatAccount = function(account) {
                return account.field_prenom + ' ' + moment(account.field_date_de_naissance).format('(DD MMM)');
            }
        }],
        templateUrl: 'src/components/select-account/select-account.html'
    };
});
